export const AddUserTemplate = `
{{{searchInput}}}
<p class="add-user__loading" style="display: none">...Loading</p>
<ul class="add-user__users">
  <li class="add-user__empty" style="display: none">No users found</li>
</ul>
{{{addToChatButton}}}
`;
